/**
 * @flow
 * @relayHash 576c7e9cf8b76f8fffd8ca9d29bf0a21
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetail_TriggerWelcomeCampaign_MutationVariables = {|
  input: {
    travelerId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type ClientDetail_TriggerWelcomeCampaign_MutationResponse = {|
  +triggerWelcomeCampaign: ?{|
    +traveler: ?{|
      +welcomeCampaign: boolean;
    |};
  |};
|};
*/


/*
mutation ClientDetail_TriggerWelcomeCampaign_Mutation(
  $input: TriggerWelcomeCampaignInput!
) {
  triggerWelcomeCampaign(input: $input) {
    traveler {
      welcomeCampaign
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "TriggerWelcomeCampaignInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetail_TriggerWelcomeCampaign_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "TriggerWelcomeCampaignInput!"
          }
        ],
        "concreteType": "TriggerWelcomeCampaignPayload",
        "name": "triggerWelcomeCampaign",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "traveler",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "welcomeCampaign",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetail_TriggerWelcomeCampaign_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "TriggerWelcomeCampaignInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "ClientDetail_TriggerWelcomeCampaign_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "TriggerWelcomeCampaignInput!"
          }
        ],
        "concreteType": "TriggerWelcomeCampaignPayload",
        "name": "triggerWelcomeCampaign",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "traveler",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "welcomeCampaign",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation ClientDetail_TriggerWelcomeCampaign_Mutation(\n  $input: TriggerWelcomeCampaignInput!\n) {\n  triggerWelcomeCampaign(input: $input) {\n    traveler {\n      welcomeCampaign\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Clients/__generated__/ClientDetail_TriggerWelcomeCampaign_Mutation.graphql.js